export default [{
  header: 'Gestión de gastos',
  icon: 'PackageIcon',
  i18n: 'Apps',
  items: [
    {
      url: '/gastos/panel',
      name: 'Panel',
      icon: 'GridIcon',
      slug: 'panel',
      permiso: 'WB000'
    }
  ]
}];
